import React from 'react';

export default class ContractRecord extends React.Component {
  render() {
    // TODO contract record
    return <div>contract record</div>;
  }
}
